// extracted by mini-css-extract-plugin
export default {"button_dark":"ButtonDark_button_dark__RcGjY"};